webpackJsonp([236655976900686],{

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.GridItem = exports.Grid = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFlipMove = __webpack_require__(148);
	
	var _reactFlipMove2 = _interopRequireDefault(_reactFlipMove);
	
	var _gridModule = __webpack_require__(144);
	
	var _gridModule2 = _interopRequireDefault(_gridModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GridItem = function (_React$PureComponent) {
	  _inherits(GridItem, _React$PureComponent);
	
	  function GridItem() {
	    _classCallCheck(this, GridItem);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  GridItem.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        size = _props.size;
	
	    var classNames = [_gridModule2.default['gridItem--' + size]];
	
	    if (className) {
	      classNames.push(className);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: classNames.join(' ') },
	      _react2.default.createElement(
	        'div',
	        { className: _gridModule2.default.gridItemContentWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _gridModule2.default.gridItemContent },
	          this.props.children
	        )
	      )
	    );
	  };
	
	  return GridItem;
	}(_react2.default.PureComponent);
	
	GridItem.propTypes = {
	  size: _propTypes2.default.string.isRequired,
	  className: _propTypes2.default.string
	};
	
	GridItem.defaultProps = {
	  size: '1x1'
	};
	
	var Grid = function (_React$PureComponent2) {
	  _inherits(Grid, _React$PureComponent2);
	
	  function Grid() {
	    _classCallCheck(this, Grid);
	
	    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
	  }
	
	  Grid.prototype.renderChildren = function renderChildren() {
	    var children = this.props.children;
	
	    var test = [];
	    // generate rows
	    _react2.default.Children.forEach(children, function (child) {
	      test.push(child);
	    });
	
	    return test;
	  };
	
	  Grid.prototype.render = function render() {
	    var _this3 = this;
	
	    var classes = [_gridModule2.default.grid];
	
	    if (this.props.className) {
	      classes.push(this.props.className);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: _gridModule2.default.container },
	      this.props.flip ? _react2.default.createElement(
	        _reactFlipMove2.default,
	        {
	          easing: 'ease-out',
	          className: classes.join(' '),
	          duration: 250,
	          staggerDurationBy: 50,
	          staggerDelayBy: 50,
	          onStartAll: function onStartAll() {
	            if (_this3.props.onFlipStart) {
	              _this3.props.onFlipStart();
	            }
	          },
	          onFinishAll: function onFinishAll() {
	            if (_this3.props.onFlipFinish) {
	              _this3.props.onFlipFinish();
	            }
	          }
	        },
	        this.renderChildren()
	      ) : _react2.default.createElement(
	        'div',
	        { className: classes.join(' ') },
	        this.props.children
	      )
	    );
	  };
	
	  return Grid;
	}(_react2.default.PureComponent);
	
	exports.Grid = Grid;
	exports.GridItem = GridItem;

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.parseQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _globalState = __webpack_require__(6);
	
	var _globalState2 = _interopRequireDefault(_globalState);
	
	var _filterSort = __webpack_require__(57);
	
	var _headerFilterSortModule = __webpack_require__(22);
	
	var _headerFilterSortModule2 = _interopRequireDefault(_headerFilterSortModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var container = _headerFilterSortModule2.default.container,
	    list = _headerFilterSortModule2.default.list,
	    item = _headerFilterSortModule2.default.item,
	    itemActive = _headerFilterSortModule2.default.itemActive;
	
	var FilterSort = function (_React$PureComponent) {
	  _inherits(FilterSort, _React$PureComponent);
	
	  function FilterSort(props) {
	    _classCallCheck(this, FilterSort);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this.listenHistory = _this.listenHistory.bind(_this);
	    _this.queriesToGlobalStateMap = _this.queriesToGlobalState();
	    return _this;
	  }
	
	  FilterSort.prototype.renderOptions = function renderOptions(options, current, stateKey, propKey) {
	    var _this2 = this;
	
	    var qArgs = {};
	    for (var key in this.queriesToGlobalStateMap) {
	      qArgs[key] = this.props[key];
	    }
	
	    return options.map(function (option) {
	      return _react2.default.createElement(
	        'li',
	        {
	          key: option.value,
	          className: current === option.value ? itemActive : item,
	          onClick: function onClick() {
	            var _extends2;
	
	            var q = (0, _filterSort.buildQuery)(_extends({}, qArgs, (_extends2 = {}, _extends2[propKey] = option.value, _extends2)), true);
	
	            if (option.value !== current) {
	              var _globalState$setState;
	
	              window.___gatsbyNavigateTo('' + _this2.props.location.pathname + q);
	
	              _globalState2.default.setState((_globalState$setState = {}, _globalState$setState[stateKey] = option.value, _globalState$setState));
	            }
	          }
	        },
	        option.label
	      );
	    });
	  };
	
	  FilterSort.prototype.componentDidMount = function componentDidMount() {
	    this.setGlobalStateFromPath(this.props.location.search);
	    this.unlistenHistory = this.props.history.listen(this.listenHistory);
	  };
	
	  FilterSort.prototype.listenHistory = function listenHistory(location) {
	    this.setGlobalStateFromPath(location.search);
	  };
	
	  FilterSort.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlistenHistory();
	  };
	
	  FilterSort.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.setGlobalStateFromPath(nextProps.location.search);
	  };
	
	  FilterSort.prototype.setGlobalStateFromPath = function setGlobalStateFromPath(getQuery) {
	    var initial = {};
	    for (var key in this.queriesToGlobalStateMap) {
	      initial[key] = null;
	    }
	    var newQuery = (0, _filterSort.parseQuery)(getQuery, initial);
	
	    var changed = false;
	    var newState = {};
	    for (var _key in this.queriesToGlobalStateMap) {
	      var globalKey = this.queriesToGlobalStateMap[_key];
	
	      if (_globalState2.default.state[globalKey] !== newQuery[_key]) {
	        changed = true;
	      }
	
	      newState[globalKey] = newQuery[_key];
	    }
	
	    if (changed) {
	      _globalState2.default.setState(newState);
	    }
	  };
	
	  FilterSort.prototype.renderContent = function renderContent() {
	    return null;
	  };
	
	  FilterSort.prototype.render = function render() {
	    var _props$inHeader = this.props.inHeader,
	        inHeader = _props$inHeader === undefined ? true : _props$inHeader;
	
	
	    if (!inHeader) {
	      return _react2.default.createElement(
	        'div',
	        { className: _headerFilterSortModule2.default.notInHeader },
	        this.renderContent()
	      );
	    } else {
	      return this.renderContent();
	    }
	  };
	
	  return FilterSort;
	}(_react2.default.PureComponent);
	
	exports.default = FilterSort;
	exports.parseQuery = _filterSort.parseQuery;

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _filterSort = __webpack_require__(40);
	
	var _filterSort2 = _interopRequireDefault(_filterSort);
	
	var _stateProvider = __webpack_require__(16);
	
	var _stateProvider2 = _interopRequireDefault(_stateProvider);
	
	var _stringTranslation = __webpack_require__(13);
	
	var _globalState = __webpack_require__(6);
	
	var _globalState2 = _interopRequireDefault(_globalState);
	
	var _headerFilterSortModule = __webpack_require__(22);
	
	var _headerFilterSortModule2 = _interopRequireDefault(_headerFilterSortModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var container = _headerFilterSortModule2.default.container,
	    list = _headerFilterSortModule2.default.list;
	
	var PortfolioFilter = function (_FilterSort) {
	  _inherits(PortfolioFilter, _FilterSort);
	
	  function PortfolioFilter() {
	    _classCallCheck(this, PortfolioFilter);
	
	    return _possibleConstructorReturn(this, _FilterSort.apply(this, arguments));
	  }
	
	  PortfolioFilter.prototype.queriesToGlobalState = function queriesToGlobalState() {
	    return {
	      filter: 'portfolioFilter'
	    };
	  };
	
	  PortfolioFilter.prototype.renderContent = function renderContent() {
	    var _this2 = this;
	
	    var _parseQuery = (0, _filterSort.parseQuery)(this.props.location.search, {
	      filter: null
	    }),
	        filter = _parseQuery.filter;
	
	    var filterOptions = [{
	      label: (0, _stringTranslation.translate)('all'),
	      value: null
	    }].concat(_globalState2.default.state.portfolioCategories.filter(function (category) {
	      return category.lang === _this2.props.language;
	    }).map(function (category) {
	      return {
	        label: category.label,
	        value: category.slug
	      };
	    }));
	
	    return _react2.default.createElement(
	      'div',
	      { className: container },
	      _react2.default.createElement(
	        'ul',
	        { className: list },
	        this.renderOptions(filterOptions, filter, 'portfolioFilter', 'filter')
	      )
	    );
	  };
	
	  return PortfolioFilter;
	}(_filterSort2.default);
	
	exports.default = (0, _stateProvider2.default)((0, _reactRouter.withRouter)(PortfolioFilter), function (state) {
	  return {
	    filter: state.portfolioFilter,
	    language: state.language
	  };
	});
	module.exports = exports['default'];

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lazyImage = __webpack_require__(12);
	
	var _portfolioModule = __webpack_require__(87);
	
	var _portfolioModule2 = _interopRequireDefault(_portfolioModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var item = _portfolioModule2.default.item,
	    imageClass = _portfolioModule2.default.image,
	    backgroundClass = _portfolioModule2.default.background;
	
	var PortoflioItem = function (_React$PureComponent) {
	  _inherits(PortoflioItem, _React$PureComponent);
	
	  function PortoflioItem() {
	    _classCallCheck(this, PortoflioItem);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  PortoflioItem.prototype.render = function render() {
	    var _props = this.props,
	        image = _props.image,
	        title = _props.title,
	        permalink = _props.permalink,
	        size = _props.size;
	
	
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: permalink, className: item },
	      _react2.default.createElement(_lazyImage.Image, {
	        style: { position: 'absolute' },
	        sizes: image,
	        alt: title,
	        className: imageClass
	      }),
	      _react2.default.createElement('div', { className: backgroundClass }),
	      _react2.default.createElement(
	        'div',
	        { className: _portfolioModule2.default.titleWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _portfolioModule2.default.title },
	          title
	        )
	      )
	    );
	  };
	
	  return PortoflioItem;
	}(_react2.default.PureComponent);
	
	PortoflioItem.propTypes = {
	  title: _propTypes2.default.any,
	  image: _propTypes2.default.any,
	  permalink: _propTypes2.default.string.isRequired
	};
	
	PortoflioItem.defaultProps = {
	  title: 'nazwa firmy tytuł projektu trzy linijki',
	  permalink: '/#'
	};
	
	exports.default = PortoflioItem;
	module.exports = exports['default'];

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _headerSpacer = __webpack_require__(20);
	
	var _headerSpacer2 = _interopRequireDefault(_headerSpacer);
	
	var _portfolioFilter = __webpack_require__(113);
	
	var _portfolioFilter2 = _interopRequireDefault(_portfolioFilter);
	
	var _item = __webpack_require__(114);
	
	var _item2 = _interopRequireDefault(_item);
	
	var _grid = __webpack_require__(111);
	
	var _navigation = __webpack_require__(24);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _stateProvider = __webpack_require__(16);
	
	var _stateProvider2 = _interopRequireDefault(_stateProvider);
	
	var _globalState = __webpack_require__(6);
	
	var _globalState2 = _interopRequireDefault(_globalState);
	
	var _linkBuilder = __webpack_require__(21);
	
	var _linkBuilder2 = _interopRequireDefault(_linkBuilder);
	
	var _portfolioModule = __webpack_require__(87);
	
	var _portfolioModule2 = _interopRequireDefault(_portfolioModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PortfolioArchiveComponent = function (_React$PureComponent) {
	  _inherits(PortfolioArchiveComponent, _React$PureComponent);
	
	  function PortfolioArchiveComponent(props) {
	    _classCallCheck(this, PortfolioArchiveComponent);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this.portfolio = _this.props.data && _this.props.data.items ? _this.props.data.items.edges.map(function (edge) {
	      return _extends({}, edge.node, {
	        categories: edge.node.portfolio_cat.map(function (cat) {
	          return _globalState2.default.state.portfolioCategories.find(function (gcat) {
	            return typeof cat === 'number' && cat === gcat.id || typeof cat === 'object' && cat.slug === gcat.slug;
	          });
	        })
	      });
	    }) : [];
	    return _this;
	  }
	
	  PortfolioArchiveComponent.prototype.render = function render() {
	    var _props = this.props,
	        filter = _props.filter,
	        windowWide = _props.windowWide;
	
	    var portfolio = this.portfolio.filter(function (project) {
	      return filter === null || project.categories.filter(function (cat) {
	        return cat.slug === filter;
	      }).length > 0;
	    });
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_headerSpacer2.default, null),
	      !windowWide && _react2.default.createElement(_portfolioFilter2.default, { inHeader: false }),
	      _react2.default.createElement(
	        _grid.Grid,
	        { flip: true },
	        portfolio.map(function (project, index) {
	          var size = project.archive.size || '1x1';
	          return _react2.default.createElement(
	            _grid.GridItem,
	            { key: 'test_' + project.slug, size: size },
	            _react2.default.createElement(_item2.default, {
	              size: size,
	              image: project.archive.thumb,
	              permalink: (0, _linkBuilder2.default)({
	                slug: project.slug,
	                type: 'portfolio',
	                lang: project.lang
	              }),
	              title: project.title
	            })
	          );
	        })
	      ),
	      _react2.default.createElement(_navigation2.default, null)
	    );
	  };
	
	  return PortfolioArchiveComponent;
	}(_react2.default.PureComponent);
	
	exports.default = (0, _stateProvider2.default)(PortfolioArchiveComponent, function (state) {
	  return {
	    filter: state.portfolioFilter,
	    windowWide: state.windowWidth > 1200
	  };
	});
	
	// export default PortfolioArchiveComponent;
	
	module.exports = exports['default'];

/***/ }),

/***/ 144:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-styles-components----grid-module---container---3OD6v src-styles-components----container-module---container---1YJKJ","grid":"src-styles-components----grid-module---grid---1h1zR","gridItem":"src-styles-components----grid-module---gridItem---MD9uo","gridItemContentWrapper":"src-styles-components----grid-module---gridItemContentWrapper---K1dzV","gridItemContent":"src-styles-components----grid-module---gridItemContent---1NHz9","gridItem--1x1":"src-styles-components----grid-module---gridItem--1x1---3PW2Y src-styles-components----grid-module---gridItem---MD9uo","gridItem--2x2":"src-styles-components----grid-module---gridItem--2x2---xIAS1 src-styles-components----grid-module---gridItem---MD9uo","gridItem--1x2":"src-styles-components----grid-module---gridItem--1x2---3hNuq src-styles-components----grid-module---gridItem---MD9uo"};

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"notInHeader":"src-styles-components----headerFilterSort-module---notInHeader---1bvWw","container":"src-styles-components----headerFilterSort-module---container---1OZuO","list":"src-styles-components----headerFilterSort-module---list---2Kylf","item":"src-styles-components----headerFilterSort-module---item---2Dx6H","itemActive":"src-styles-components----headerFilterSort-module---itemActive---3cT3f src-styles-components----headerFilterSort-module---item---2Dx6H"};

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"item":"src-styles-components----portfolio-module---item---2bT7E","image":"src-styles-components----portfolio-module---image---2HNcP","background":"src-styles-components----portfolio-module---background---2Vty3","titleWrapper":"src-styles-components----portfolio-module---titleWrapper---3XK6v","title":"src-styles-components----portfolio-module---title---1gVmS"};

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _page = __webpack_require__(17);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _stringTranslation = __webpack_require__(13);
	
	var _portfolioArchive = __webpack_require__(239);
	
	var _portfolioArchive2 = _interopRequireDefault(_portfolioArchive);
	
	var _seo = __webpack_require__(32);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PortfolioArchivePost = function (_Page) {
	  _inherits(PortfolioArchivePost, _Page);
	
	  function PortfolioArchivePost() {
	    _classCallCheck(this, PortfolioArchivePost);
	
	    return _possibleConstructorReturn(this, _Page.apply(this, arguments));
	  }
	
	  PortfolioArchivePost.prototype.onMountGlobalState = function onMountGlobalState(state) {
	    return _extends({}, state, {
	      whiteLogo: false,
	      headerWidget: 'portfolioFilter'
	    });
	  };
	
	  PortfolioArchivePost.prototype.render = function render() {
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_seo2.default, _extends({
	        title: (0, _stringTranslation.translate)('portfolio')
	      }, this.props.pathContext, {
	        key: 'seo'
	      })),
	      _react2.default.createElement(_portfolioArchive2.default, { data: this.props.data })
	    );
	  };
	
	  return PortfolioArchivePost;
	}(_page2.default);
	
	exports.default = PortfolioArchivePost;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	/*
	export const pageQuery = graphql`
	  query ArticlesQuery($lang: String!) {
	    articles: allWordpressPost(filter: { lang: { eq: $lang } }) {
	      edges {
	        node {
	          ...PostExcerptFragment
	        }
	      }
	    }
	  }
	`;
	*/

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-portfolio-archive-js-7918b13486a01d237b8a.js